import { useEffect, useState } from "react";
import API from "../../services/api";

import BasicDetails from "../../component/admin/BasicDetails";
import ProductFeatures from "../../component/admin/ProductFeatures";

import "../../css/AddProduct.css";

function AddProduct() {

    const [name, setName] = useState("");
    const [price, setPrice] = useState("");
    const [description, setDescription] = useState("");
    const [stock, setStock] = useState("");

    const [imageFile, setImageFile] = useState(null);

    const [categoryId, setCategoryId] = useState("");
    const [typeId, setTypeId] = useState("");
    const [brandId, setBrandId] = useState("");

    const [categories, setCategories] = useState([]);
    const [types, setTypes] = useState([]);
    const [brands, setBrands] = useState([]);

    const [features, setFeatures] = useState([]);
    const [featureValues, setFeatureValues] = useState({});

    useEffect(() => {

        fetchCategories();

    }, []);

    const fetchCategories = async () => {

        try {

            const res = await API.get("/api/categories");

            setCategories(res.data || []);

        } catch (error) {

            console.log(error);

        }

    };

    const fetchTypes = async (categoryId) => {

        try {

            const res = await API.get(`/api/types/${categoryId}`);

            setTypes(res.data || []);

        } catch (error) {

            console.log(error);

        }

    };

    const fetchBrands = async (categoryId) => {

        try {

            const res = await API.get(`/api/admin/brand/${categoryId}`);

            setBrands(res.data || []);

        } catch (error) {

            console.log(error);

        }

    };

    const fetchFeatures = async (typeId) => {

        try {

            const res = await API.get(`/api/admin/features/${typeId}`);

            setFeatures(res.data || []);

        } catch (error) {

            console.log(error);

        }

    };

    const handleFeatureChange = (featureId, value) => {

        setFeatureValues(prev => ({

            ...prev,

            [featureId]: value

        }));

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!categoryId || !typeId || !brandId) {

            alert("Please select Category, Product Type and Brand.");

            return;

        }

        const featureArray = Object.keys(featureValues).map(id => ({

            featureId: Number(id),

            value: featureValues[id]

        }));

        const formData = new FormData();

        formData.append("name", name);
        formData.append("price", price);
        formData.append("description", description);
        formData.append("stock", stock);
        formData.append("categoryId", Number(categoryId));
        formData.append("typeId", Number(typeId));
        formData.append("brandId", Number(brandId));
        formData.append("image", imageFile);
        formData.append("features", JSON.stringify(featureArray));

        try {

            await API.post(
                "/api/admin/products/addProduct",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );

            alert("Product Added Successfully");

            setName("");
            setPrice("");
            setDescription("");
            setStock("");

            setImageFile(null);

            setCategoryId("");
            setTypeId("");
            setBrandId("");

            setTypes([]);
            setBrands([]);
            setFeatures([]);

            setFeatureValues({});

        } catch (error) {

            console.log(error);

            alert("Unable to Add Product");

        }

    };

    return (

        <div className="container py-4">

            <h2 className="mb-4">

                Add Product

            </h2>

            <div className="row">

                <div className="col-lg-6 mb-4">

                    <BasicDetails

                        name={name}
                        setName={setName}

                        price={price}
                        setPrice={setPrice}

                        stock={stock}
                        setStock={setStock}

                        description={description}
                        setDescription={setDescription}

                        imageFile={imageFile}
                        setImageFile={setImageFile}

                        categoryId={categoryId}
                        setCategoryId={setCategoryId}

                        categories={categories}

                        fetchBrands={fetchBrands}
                        fetchTypes={fetchTypes}

                        brandId={brandId}
                        setBrandId={setBrandId}

                        brands={brands}

                        typeId={typeId}
                        setTypeId={setTypeId}

                        types={types}

                        fetchFeatures={fetchFeatures}

                        setFeatures={setFeatures}

                        setFeatureValues={setFeatureValues}

                    />

                </div>

                <div className="col-lg-6 mb-4">

                    <ProductFeatures

                        typeId={typeId}

                        features={features}

                        featureValues={featureValues}

                        handleFeatureChange={handleFeatureChange}

                    />

                </div>

            </div>

            <button

                className="btn btn-success w-100 py-3"

                onClick={handleSubmit}

            >

                Add Product

            </button>

        </div>

    );

}

export default AddProduct;